<template>
  <div class="row w-80 logos">
    <div class="col-12 col-lg-5 offset-lg-1">
      <a href="https://www.avax.network/" target="_blank">
        <img
          class="img-fluid px-3 mb-5"
          src="/assets/images/avalanche.webp"
          alt="Avalanche"
        />
      </a>
    </div>
    <div class="col-12 col-lg-5">
      <a href="https://avalaunch.app/" target="_blank">
        <img
          class="img-fluid px-3 mb-5"
          src="/assets/images/avalaunch.webp"
          alt="Avalaunch"
        />
      </a>
    </div>
    <!-- <div class="col-4">
      <a href="#" target="_blank">
        <img class="img-fluid px-3" src="/assets/images/binance.webp" alt="Binance" />
      </a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Logos",
};
</script>

<style lang="scss" scoped>
.logos {
  * {
    text-align: center;
  }
  img {
    animation-name: cardshake;
    -webkit-filter: drop-shadow(0px 0px 1rem rgba(255, 255, 255, 0.25));
    filter: drop-shadow(0px 0px 1rem rgba(255, 255, 255, 0.25));
    &:hover {
      animation-name: hoverscale;
      animation-duration: 0.3s;
      animation-iteration-count: 1;
      transform: scale(1.1, 1.1);
    }
  }
}
</style>
